import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';

import { ChipContComponent } from '@ux/components/chip/chip-cont/chip-cont.component';

@NgModule({
  declarations: [
    ChipContComponent
  ],
  imports: [
    CommonModule,
    TranslocoModule,
    RouterModule,
  ],
  exports: [
    ChipContComponent
  ]
})
export class ChipModule { }
